module.exports = __webpack_public_path__ + "static/media/chess-rook.e493299c.svg";